import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/IndexView.vue'),
    meta: {
      saveScrollPosition: false
    }
  },
  {
    path: '/caselist',
    name: 'caselist',
    component: () => import('../views/CaseList.vue'),
    meta: {
      saveScrollPosition: false
    }
  },
  {
    path: '/wantAd',
    name: 'wantAd',
    component: () => import('../views/WantAd.vue'),
    meta: {
      saveScrollPosition: false
    }
  },

]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})
// router.beforeEach((to, from, next) => {
//   const observer = new IntersectionObserver((entries) => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting && window.scrollY === 0) {
//         observer.disconnect();
//         next();
//       }
//     });
//   });

//   observer.observe(document.body);
// });
router.beforeEach((to,from,next) => {
  document.body.scrollTo = 0;
  document.documentElement.scrollTop = 0;
  window.scrollY = 0;
  next();
})
export default router
